(function () {
  function updateCardImage(card, newImage) {
    if (!card || !newImage) return;

    const mainImage = card.querySelector('[data-card-main-image]');
    if (!mainImage) return;

    mainImage.src = newImage;
    mainImage.setAttribute('srcset', newImage);
  }

  function updateCardLinks(card, newUrl) {
    if (!card || !newUrl) return;

    const links = card.querySelectorAll('[data-card-product-link]');
    links.forEach((link) => {
      link.href = newUrl;
    });
  }

  function handleSwatchChange(input) {
    const card = input.closest('[data-card-product]');
    if (!card) return;

    const newImage = input.dataset.variantImage;
    const newUrl = input.dataset.variantUrl;

    updateCardImage(card, newImage);
    updateCardLinks(card, newUrl);
  }

  document.addEventListener('change', function (event) {
    const input = event.target;

    if (!input.matches('.collection-product-card__swatch input[type="radio"]')) return;

    handleSwatchChange(input);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.collection-product-card__swatch input[type="radio"]:checked')
      .forEach((input) => {
        handleSwatchChange(input);
      });
  });
})();